import { defineMessages } from "react-intl"

export const messages = defineMessages({
  quoteTitle: {
    id: "nodeSubNodeForm_quote_title",
    defaultMessage: "Citace"
  }
})
